module.exports = __webpack_public_path__ + "img/FPT01.7b85cdd1.svg";